import { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { useReducedMotion } from '../../../hooks/useReducedMotion';
import './projectCard.scss';

export default function ProjectCard({ project, index }) {
  const ref = useRef(null);
  const reduced = useReducedMotion();
  const [tilt, setTilt] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e) => {
    if (reduced) return;
    const rect = ref.current.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width - 0.5) * 12;
    const y = ((e.clientY - rect.top) / rect.height - 0.5) * -12;
    setTilt({ x: y, y: x });
  };
  const handleMouseLeave = () => setTilt({ x: 0, y: 0 });

  return (
    <motion.article
      ref={ref}
      className="project-card"
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ delay: index * 0.08, duration: 0.7, ease: [0.25, 1, 0.5, 1] }}
      style={{
        transform: `perspective(1000px) rotateX(${tilt.x}deg) rotateY(${tilt.y}deg)`,
      }}
    >
      <div className="project-card__image">
        <img src={project.image} alt={project.title} loading="lazy" />
      </div>
      <div className="project-card__body">
        <div className="project-card__header">
          <h3 className="project-card__title">{project.title}</h3>
          <span className="project-card__year">{project.year}</span>
        </div>
        <div className="project-card__role">{project.role}</div>
        <p className="project-card__description">{project.description}</p>
        <div className="project-card__tech">
          {project.techStack.map((t) => (
            <span key={t} className="project-card__tag">{t}</span>
          ))}
        </div>
        <div className="project-card__links">
          {project.liveUrl && (
            <a className="project-card__link" href={project.liveUrl} target="_blank" rel="noreferrer">
              Live →
            </a>
          )}
          {project.githubUrl && (
            <a className="project-card__link" href={project.githubUrl} target="_blank" rel="noreferrer">
              GitHub →
            </a>
          )}
          {project.privacyPolicyUrl && (
            <a className="project-card__link is-muted" href={project.privacyPolicyUrl} target="_blank" rel="noreferrer">
              Privacy
            </a>
          )}
        </div>
      </div>
    </motion.article>
  );
}
